import { render, staticRenderFns } from "./TheUserRequestsList.vue?vue&type=template&id=7bc0f80c&"
import script from "./TheUserRequestsList.vue?vue&type=script&lang=js&"
export * from "./TheUserRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports